import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';


const CaretPrevIcon = (props) => (
  <SvgIcon viewBox="0 0 9 15" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.383235 8.11883L6.50678 14.2424C6.84849 14.5841 7.40251 14.5841 7.74422 14.2424C8.08593 13.9007 8.08593 13.3467 7.74422 13.0049L2.23939 7.50011L7.74422 1.99528C8.08593 1.65357 8.08593 1.09955 7.74422 0.757841C7.40251 0.416133 6.84849 0.416133 6.50678 0.757841L0.383235 6.88139C0.0415259 7.2231 0.0415259 7.77712 0.383235 8.11883Z"
    />
  </SvgIcon>
);

export default CaretPrevIcon;

